import React from 'react';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  return (
    <div className="privacy-policy-page">
      <div className="privacy-hero">
        <div className="container">
          <h1 className="privacy-title">Privacy Policy</h1>
          <p className="privacy-date">Last Updated: December 7, 2025</p>
        </div>
      </div>

      <div className="privacy-content">
        <div className="container">
          <section className="policy-section">
            <h2>Introduction</h2>
            <p>
              This Privacy Policy explains how our app handles user information. We respect your privacy and are committed to protecting it. Our app does not collect, store, or share any personal information beyond what is required by the underlying frameworks and platforms used to deliver the app.
            </p>
          </section>

          <section className="policy-section">
            <h2>Information We Collect</h2>
            <ul>
              <li>
                <strong>No direct collection:</strong> We do not collect, store, or process any personal data from users.
              </li>
              <li>
                <strong>Platform requirements:</strong> The app may rely on information automatically handled by:
                <ul>
                  <li>.NET MAUI framework (for app functionality and compatibility).</li>
                  <li>Google Play services (for distribution, updates, crash reporting, and compliance with Google Play policies).</li>
                </ul>
              </li>
            </ul>
            <p>Any data handled by these platforms is subject to their respective privacy policies.</p>
          </section>

          <section className="policy-section">
            <h2>How Information Is Used</h2>
            <ul>
              <li>Information required by Google Play or .NET MAUI is used solely to ensure the app runs correctly, is distributed securely, and remains compliant with platform requirements.</li>
              <li>We do not use this information for analytics, advertising, or tracking.</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>Sharing of Information</h2>
            <ul>
              <li>We do not share, sell, or disclose any user information to third parties.</li>
              <li>Any data processed by Google Play or .NET MAUI is managed according to their own privacy practices.</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>Children's Privacy</h2>
            <p>
              Our app does not knowingly collect or process any personal information from children.
            </p>
          </section>

          <section className="policy-section">
            <h2>Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy if required by Google Play or framework changes. Updates will be reflected here with a new effective date.
            </p>
          </section>

          <section className="policy-section">
            <h2>Contact Us</h2>
            <p>
              If you have questions about this Privacy Policy, please contact us at:
            </p>
            <p className="contact-info">
              📧 <a href="mailto:tarpindergrewal@createmyapp.ca">tarpindergrewal@createmyapp.ca</a><br />
              📱 604-773-1594<br />
              📍 Surrey, BC, Canada
            </p>
          </section>

          <div className="back-home">
            <a href="/" className="back-button">← Back to Home</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
